<input class="td-wb-toggle-input"
        type="radio"
        [attr.id]="finalRadioId()"
        [name]="finalName()"
        [value]="value()"
        [attr.tabindex]="tabIndex()"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-labelledby]="ariaLabelledBy()"
        [checked]="checked()"
        [disabled]="disabled()"
        (change)="onInputChange($event)"
        (click)="onInputClick($event)"
        (keydown.space)="onInputChange($event)">
<label class="td-wb-toggle-label" [attr.for]="finalRadioId()">
  <ng-content />
</label>
